export default __webpack_public_path__ + "static/tabsSectionBg-c8f74d00049092e26e5f4f724819f4bc.png";